import { Link } from '@tanstack/react-router'
import { AtSign, MessageSquare } from 'lucide-react'
import { cn } from '@/lib/utils'

export type GroupsInboxView = 'mentions' | 'replies'

interface Props {
  activeView: GroupsInboxView | null
}

export function GroupsInboxLinks({ activeView }: Props) {
  return (
    <div className="space-y-0.5">
      <InboxLink
        to="/groups/mentions"
        label="Mentions"
        icon={<AtSign className="h-4 w-4" />}
        active={activeView === 'mentions'}
      />
      <InboxLink
        to="/groups/replies"
        label="Replies"
        icon={<MessageSquare className="h-4 w-4" />}
        active={activeView === 'replies'}
      />
    </div>
  )
}

function InboxLink({
  to,
  label,
  icon,
  active,
}: {
  to: string
  label: string
  icon: React.ReactNode
  active: boolean
}) {
  return (
    <Link
      to={to}
      className={cn(
        'flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors',
        active ? 'bg-primary/10 text-primary' : 'text-foreground hover:bg-surface-soft',
      )}
    >
      {icon}
      <span>{label}</span>
    </Link>
  )
}
